var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastestPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.5 0C4.60625 0 3.875 0.73125 3.875 1.625V24.375C3.875 25.2687 4.60625 26 5.5 26H21.75C22.6437 26 23.375 25.2687 23.375 24.375V6.5L16.875 0H5.5Z",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.5 6.5H23.375L16.875 0V4.875C16.875 5.76875 17.6062 6.5 18.5 6.5Z",
    fill: "#B0B7BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.375 11.375L18.5 6.5H23.375V11.375Z",
    fill: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.125 21.125C20.125 21.5719 19.7594 21.9375 19.3125 21.9375H1.4375C0.990625 21.9375 0.625 21.5719 0.625 21.125V13C0.625 12.5531 0.990625 12.1875 1.4375 12.1875H19.3125C19.7594 12.1875 20.125 12.5531 20.125 13V21.125Z",
    fill: "#F15642"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.1665 15.3944C4.1665 15.1799 4.3355 14.9459 4.60769 14.9459H6.10838C6.95338 14.9459 7.71388 15.5114 7.71388 16.5953C7.71388 17.6223 6.95338 18.1943 6.10838 18.1943H5.02369V19.0523C5.02369 19.3383 4.84169 19.5 4.60769 19.5C4.39319 19.5 4.1665 19.3383 4.1665 19.0523V15.3944ZM5.02369 15.7641V17.3826H6.10838C6.54388 17.3826 6.88838 16.9983 6.88838 16.5953C6.88838 16.1411 6.54388 15.7641 6.10838 15.7641H5.02369ZM8.98625 19.5C8.77175 19.5 8.53775 19.383 8.53775 19.0978V15.4074C8.53775 15.1742 8.77175 15.0044 8.98625 15.0044H10.4739C13.4428 15.0044 13.3778 19.5 10.5324 19.5H8.98625ZM9.39575 15.7974V18.7078H10.4739C12.2281 18.7078 12.3061 15.7974 10.4739 15.7974H9.39575ZM14.4308 15.8494V16.8821H16.0875C16.3215 16.8821 16.5555 17.1161 16.5555 17.3428C16.5555 17.5573 16.3215 17.7328 16.0875 17.7328H14.4308V19.097C14.4308 19.3245 14.2691 19.4992 14.0416 19.4992C13.7556 19.4992 13.5809 19.3245 13.5809 19.097V15.4066C13.5809 15.1734 13.7564 15.0036 14.0416 15.0036H16.3223C16.6083 15.0036 16.7773 15.1734 16.7773 15.4066C16.7773 15.6146 16.6083 15.8486 16.3223 15.8486H14.4308V15.8494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.3125 21.9375H3.875V22.75H19.3125C19.7594 22.75 20.125 22.3844 20.125 21.9375V21.125C20.125 21.5719 19.7594 21.9375 19.3125 21.9375Z",
    fill: "#CAD1D8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastestPdf);
export default __webpack_public_path__ + "static/media/LastestPdf.c3fc56fdbdc473d0d796cf534179f013.svg";
export { ForwardRef as ReactComponent };